var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIdentification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8.25h3a.75.75 0 01.75.75v1.5h-4.5V9a.75.75 0 01.75-.75zM18 7.5a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: "#45464F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 13.5h-9A1.502 1.502 0 0112 12V3a1.502 1.502 0 011.5-1.5h9A1.502 1.502 0 0124 3v9a1.502 1.502 0 01-1.5 1.5zM13.5 3v9h9V3h-9zM11.25 22.5h-1.5v-3a2.21 2.21 0 00-2.25-2.25h-3a2.21 2.21 0 00-2.25 2.25v3H.75v-3a3.714 3.714 0 013.75-3.75h3a3.714 3.714 0 013.75 3.75v3zM6 8.25a2.25 2.25 0 110 4.5 2.25 2.25 0 010-4.5zm0-1.5a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5z",
    fill: "#45464F"
  })));
}
export default SvgUserIdentification;